import apiService from '../apiService';

const ailaService = {
  /**
   * Aila's AI summary for one record. parentType is 'contact' | 'matter';
   * refresh=true skips the backend's cached copy and asks for a fresh one.
   */
  async getSummary({ parentType, parentId, refresh = false }) {
    try {
      const response = await apiService.get(
        `/${parentType}s/${parentId}/aila-summary${refresh ? '?refresh=1' : ''}`
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default ailaService;
